import { OrganizationUsersState } from "@idw-types/state/organization-users-state";
import { OrganizationUsersActionTypes, OrganizationUsersActions } from "../actions/organization-users-actions";
import { AxnAdminUser, FormattedAxnAdminUser } from "@idw-types/data/axn-admin-user";
import { AxnAdminUserAccountStateTypes } from "@enums/axn-admin-user-account-state-types";

export const initialOrganizationUsersState: OrganizationUsersState = {
    organizationUsers: {
        isLoading: false,
        organizationUsers: null
    },
    organizationUsersRoles: []
};

export const organizationUsersReducer = (
    state: OrganizationUsersState = initialOrganizationUsersState,
    action: OrganizationUsersActions
): OrganizationUsersState => {
    switch (action.type) {
        // Organization Users
        case OrganizationUsersActionTypes.SET_ORGANIZATION_USERS_LOADING:
            return {
                ...state,
                organizationUsers: {
                    ...(action.payload.isLoading
                        ? { ...initialOrganizationUsersState.organizationUsers }
                        : { ...state.organizationUsers }),
                    isLoading: action.payload.isLoading
                }
            };
        case OrganizationUsersActionTypes.SET_ORGANIZATION_USERS:
            return {
                ...state,
                organizationUsers: {
                    ...state.organizationUsers,
                    organizationUsers: action.payload.axnAdminUsers,
                    isLoading: false
                }
            };
        case OrganizationUsersActionTypes.SET_ORGANIZATION_USERS_FILTER_ROLES:
            return {
                ...state,
                organizationUsersRoles: action.payload.organizationUsersRoles
            };
        case OrganizationUsersActionTypes.REPLACE_ORGANIZATION_USER: {
            return {
                ...state,
                organizationUsers: {
                    ...state.organizationUsers,
                    organizationUsers: replaceOrganizationUser(state.organizationUsers.organizationUsers, action.payload.organizationUser, action.payload.status)
                }
            }
        }
        default:
            return state;
    }
};

const replaceOrganizationUser = (
    organizationUsers: Array<FormattedAxnAdminUser>,
    newOrganizationUser: AxnAdminUser,
    status: AxnAdminUserAccountStateTypes
) => {
    return organizationUsers.reduce((newOrganizationusers, user) => {
        if (user.id === newOrganizationUser.id) {
            if (status !== AxnAdminUserAccountStateTypes.DELETE) {
                newOrganizationusers.push({
                    ...user,
                    status: newOrganizationUser.status
                });
            }
        } else {
            newOrganizationusers.push(user);
        }

        return newOrganizationusers;
    }, [] as Array<FormattedAxnAdminUser>);
};